/**
 * Menyuda ko'rsatish/yashirish uchun ishlatiladigan ruxsatlar — API chaqiruvlari
 * (EnumPermissions) bilan ARALASHMAYDI. Backend shu kalitlarni alohida
 * permission sifatida yaratgan va rollarga biriktiradi.
 *
 * Faqat CHILD (leaf) menyu punktlari kalitga ega bo'ladi — parent/dropdown
 * punktlar (masalan "olympiad_processes") o'z permissionIds'iga ega bo'lmaydi,
 * ularning ko'rinishi faqat ko'rinadigan bolalari borligiga qarab aniqlanadi
 * (lib-layout filterMenuItemsByPermission shuni avtomatik bajaradi).
 */
export enum MenuPermissions {
  // ===== ADMIN =====
  AdminDashboard = 'menuAdmin.dashboard',

  AdminUsersMenuUsers = 'menuAdmin.users_menu.users',
  AdminUsersMenuJudges = 'menuAdmin.users_menu.judges',
  AdminUsersMenuExperts = 'menuAdmin.users_menu.experts',
  AdminUsersMenuDirectors = 'menuAdmin.users_menu.directors',
  AdminUsersMenuSpecialUsers = 'menuAdmin.users_menu.special_users',

  AdminOlympiadProcessesOlimpiada = 'menuAdmin.olympiad_processes.olimpiada',
  AdminOlympiadProcessesOlimpiadaStage = 'menuAdmin.olympiad_processes.olimpiada_stage',
  AdminOlympiadProcessesVariants = 'menuAdmin.olympiad_processes.variants',
  AdminOlympiadProcessesExamSeating = 'menuAdmin.olympiad_processes.exam_seating',
  AdminOlympiadProcessesAudienceManagers = 'menuAdmin.olympiad_processes.audience_managers',
  AdminOlympiadProcessesCheckingOmrTest = 'menuAdmin.olympiad_processes.checking_omr_test',
  AdminOlympiadProcessesCheckingExpert = 'menuAdmin.olympiad_processes.checking_expert',
  AdminOlympiadProcessesResults = 'menuAdmin.olympiad_processes.results',

  AdminApplicationsMenuApplication = 'menuAdmin.applications_menu.application',
  AdminApplicationsMenuApplicationGroup = 'menuAdmin.applications_menu.application_group',
  AdminApplicationsMenuAppellations = 'menuAdmin.applications_menu.appellations',

  AdminWinners = 'menuAdmin.winners',
  AdminOlympiadMaterials = 'menuAdmin.olympiad_materials',
  AdminInternationalScienceOlympiad = 'menuAdmin.international_science_olympiad',

  AdminDirectoriesRoles = 'menuAdmin.directories.roles',
  AdminDirectoriesRegions = 'menuAdmin.directories.regions',
  AdminDirectoriesDistricts = 'menuAdmin.directories.districts',
  AdminDirectoriesSchoolGrade = 'menuAdmin.directories.school_grade',
  AdminDirectoriesSchoolSubjects = 'menuAdmin.directories.school_subjects',
  AdminDirectoriesStudyYear = 'menuAdmin.directories.study_year',
  AdminDirectoriesInstitutions = 'menuAdmin.directories.institutions',
  AdminDirectoriesSchoolTypes = 'menuAdmin.directories.school_types',
  AdminDirectoriesTranslate = 'menuAdmin.directories.translate',
  AdminDirectoriesSpLanguages = 'menuAdmin.directories.splanguages',
  AdminDirectoriesSpAnswerSheetTemplate = 'menuAdmin.directories.spanswersheettemplate',

  // ===== USER (cabinet) =====
  UserMyProfileAddUser = 'menuUser.my_profile.add_user',
  UserMyProfileMyPrize = 'menuUser.my_profile.my_prize',

  UserOlympics = 'menuUser.olympics',
  UserApplication = 'menuUser.application',
  UserApplicationGroup = 'menuUser.application_group',
  UserOlympiadTeamFormation = 'menuUser.olympiad_team_formation',
  UserSpecialUsers = 'menuUser.special_users',
  UserAppeal = 'menuUser.appeal',
  UserResult = 'menuUser.result',
  UserDemoTests = 'menuUser.demo_tests',
}
